import get from "lodash/get";
import SessionMixin from "../../../shared/mixins/sessionMixin";
import { FlashMessageService, CustomHeadersService } from "zoox-infra";
import {
  zCameraModal,
  zValidationGuestModal,
  zModalReservationCanceled
} from "zoox-components";
import ReservationServiceLocal from "@/service/reservation-service";
import GuestControlService from "@/service/guest-control-service";
import StrategyManager from "@/strategies/manager";
import PincodeInput from "vue-pincode-input";
import { mapActions, mapState } from "vuex";
import { ApiClient } from "zoox-infra";
import zModalPinError from "../../../shared/zModalPinError";
import Vue from "vue";

export default {
  name: "MultGuest",
  mixins: [SessionMixin],
  components: {
    "z-camera": zCameraModal,
    PincodeInput,
    "z-validation-guest-modal": zValidationGuestModal,
    zModalReservationCanceled,
    zModalPinError
  },
  props: [
    "paramsReady",
    "customizationSettings",
    "fieldSettingsData",
    "additionalData",
    "companyParams",
    "currentCompany"
  ],
  watch: {
    paramsReady: function(value) {
      if (value) {
        let enableRecognition = get(this.currentCompany, [
          "parameters_sc",
          "globalSettings",
          "enableRecognition"
        ]);

        this.enableRecon =
          this.mediaSupported &&
          (typeof enableRecognition === "undefined"
            ? this.enableRecon
            : enableRecognition);

        if (this.hasOne) {
          this.cardClick(
            this.currentReservation.id,
            this.currentReservation.guests[0].id
          );
        }
      }
    }
  },
  data() {
    return {
      guestControlService: new GuestControlService(),
      reservationServiceLocal: new ReservationServiceLocal(),
      apiClient: new ApiClient(Vue),
      showModalPinError: false,
      strategyManager: new StrategyManager(),
      dialog: false,
      loading: false,
      personId: "",
      reservationId: "",
      reconOpen: false,
      enableRecon: false,
      hasOne: false,
      openFaceRecognitionModalForUserRegistered: false,
      showValidationModal: false,
      selectedGuest: {
        reservationId: "",
        guestId: ""
      },
      radioGroupSelectValidationModel: null,
      radioGroupSelectValidationLabels: [
        this.$t("PIN.SEND_MAIL"),
        this.$t("PIN.SEND_SMS")
      ],
      validationModalStep: 0,
      validationCode: null,
      validationModalGuest: null,
      showBrowserModalRecomendation: false,
      showBrowserModalAlreadyFinished: false,
      guestComunicationOptions: null,
      openModalCanceled: false,
      countries: []
    };
  },
  async created() {
    await this.apiClient.get("open/country/list").then(resp => {
      this.countries = resp;
    });
    let ua = navigator.userAgent;
    if (
      (!/Chrome/i.test(ua) &&
        !/(CriOS\/){1}(\d{2}\.{1}\d{1}\.\d{4}\.\d{2}){1}( Mobile\/){1}(\d{2}E\d{3}){1}( Safari\/){1}(\d{3}\.{1}\d{1}){1}/i.test(
          ua
        )) || // Chrome UA on iPhone
      (/Chrome/i.test(ua) && /Edge/i.test(ua)) ||
      (/Chrome/i.test(ua) && /Edg/i.test(ua)) ||
      /Firefox/i.test(ua)
    ) {
      this.showBrowserModalRecomendation = true;
    }
  },
  async beforeMount() {
    const { reservationId } = this.$route.params;

    const checkReservation = await this.reservationServiceLocal.checkIfReservationIsExpiredOrCanceled(
      reservationId
    );

    if (checkReservation.status === true) {
      this.openModalCanceled = true;
    } else {
      this.openModalCanceled = false;
    }
  },
  async mounted() {
    const $context = this;
    const { reservationId, guestId } = this.$route.params;
    const { hash, fromSearch } = this.$route.query;
    $context.currentCompany = $context.companyService.getLocalCompany();

    const fromExpiredPin = localStorage.getItem("expiredPin");

    if (fromExpiredPin) {
      this.strategyManager.finishLoading();

      this.showModalPinError = true;
      localStorage.removeItem("expiredPin");
    }

    Vue.$globalEvent.$on("languageChanged", () => {
      this.radioGroupSelectValidationLabels = [
        this.$t("PIN.SEND_MAIL"),
        this.$t("PIN.SEND_SMS")
      ];
    });

    if (
      (reservationId && guestId && hash) ||
      (reservationId && guestId && !fromSearch)
    ) {
      await this.getReservation(reservationId, hash);
    }
  },
  computed: {
    ...mapState(["showSplashScreen", "isQualifiedGuest", "currentReservation"]),
    splashScreenContent() {
      switch (this.globalLocale) {
        case "pt":
          return get(this.customizationSettings, "splashScreenHtmlPt") || "";

        case "en":
          return get(this.customizationSettings, "splashScreenHtmlEn") || "";

        case "es":
          return get(this.customizationSettings, "splashScreenHtmlEs") || "";

        default:
          return get(this.customizationSettings, "splashScreenHtmlEn") || "";
      }
    },
    childrenNumber() {
      return this.currentReservation.childrenNumber;
    }
  },
  methods: {
    ...mapActions([
      "$closeSplashScreen",
      "$setIsQualifiedGuest",
      "$setCurrentReservation",
      "$setAuthenticatedPersonGuestId"
    ]),
    closeModal() {
      this.showBrowserModalRecomendation = false;
    },
    async closeAlreadyFinishedModal() {
      this.showBrowserModalAlreadyFinished = false;
    },
    closeValidationModal() {
      this.showValidationModal = false;
      this.validationModalStep = 0;
      this.validationModalGuest = null;
      this.radioGroupSelectValidationModel = null;
      this.showError = false;
    },
    async open(guest) {
      const guestsWithFnrhId = this.currentReservation.guests.map(
        g => g.fnrhId
      );

      if (guestsWithFnrhId.length >= 1) {
        localStorage.setItem("cameFromMultGuest", true);
      }

      this.selectedGuest = {
        reservationId: this.currentReservation.id,
        guestId: guest.id,
        personId: guest.personId,
        contactInfoList: guest.contactInfoList
      };

      this.selectedGuest.personId = await this.getSelectedGuestPersonId();
      if (this.selectedGuest.personId !== -1) {
        if (
          this.isQualifiedGuest &&
          this.selectedGuest.guestId === this.$route.params.guestId
        ) {
          this.$setCurrentMobileStep(1);

          this.$redirectGuestView(
            this.$route.params.reservationId,
            this.selectedGuest.guestId
          );
        } else {
          this.openValidationModal(guest);
        }
      } else {
        if (guest.isFinalized != null && guest.isFinalized === true) {
          this.showBrowserModalAlreadyFinished = true;
        } else {
          this.$redirectGuestView(
            this.selectedGuest.reservationId,
            this.selectedGuest.guestId,
            false
          );
        }
      }
    },
    async resendCode(radioGroupSelectValidationModelObj) {
      return this.sendCode(radioGroupSelectValidationModelObj);
    },
    async getSelectedGuestPersonId() {
      const { reservationId, guestId, personId } = this.selectedGuest;
      if (personId != null) {
        if (
          !this.guestComunicationOptions &&
          this.selectedGuest.contactInfoList
        )
          this.guestComunicationOptions = this.selectedGuest.contactInfoList;
        else {
          this.guestComunicationOptions = (
            await this.reservationService.getPersonId(reservationId, guestId)
          ).contactInfoList;
        }
        return personId;
      }

      const resp = await this.reservationService.getPersonId(
        reservationId,
        guestId
      );

      if (resp !== "Person not found.") {
        this.guestComunicationOptions = resp.contactInfoList;
        return resp.personId;
      }
      return -1;
    },
    openValidationModal(guest) {
      this.validationModalGuest = guest;
      this.showValidationModal = true;
    },
    reconSuccessForUserRegistered: function(resp) {
      this.openFaceRecognitionModalForUserRegistered = false;
      this.guestComunicationOptions = resp.resp.lastReservations[0].guests.filter(
        x => x.hasOwnProperty("contactInfoList")
      )[0].contactInfoList;
      this.showValidationModal = true;
    },
    reconFailForUserRegistered: function() {
      this.openFaceRecognitionModalForUserRegistered = false;
    },
    async sendCode(radioGroupSelectValidationModelObj) {
      if (radioGroupSelectValidationModelObj) {
        try {
          let resp;
          if (radioGroupSelectValidationModelObj.type === "email") {
            localStorage.setItem(
              "contactId",
              radioGroupSelectValidationModelObj.id
            );
            resp = await this.apiClient.post(`v2/portal/send-code`, {
              contactId: radioGroupSelectValidationModelObj.id,
              reservationNumber: this.currentReservation.reservationNumber
            });
          } else {
            resp = await this.apiClient.post(`portal/send-code`, {
              contactId: radioGroupSelectValidationModelObj.id
            });
          }

          if (resp.ok) {
            localStorage.setItem("selectedGuestId", this.selectedGuest.guestId);

            this.validationModalStep = 2;
            this.showError = false;
          }
        } catch (e) {
          FlashMessageService.warning(this.$t("PIN.WAIT_90_SECONDS"));
          console.error(e);
        }
      }
    },
    goToFillFnrhWithoutRecognition() {
      this.closeValidationModal();
      this.$redirectGuestView(
        this.$route.params.reservationId,
        this.selectedGuest.guestId,
        false
      );
    },
    checkValidationCode(validationObj) {
      if (validationObj.code && validationObj.code.length === 5) {
        this.loading = true;
        return this.apiClient
          .post(
            `portal/verify-code`,
            {
              contactId: validationObj.contactId,
              verificationCode: validationObj.code
            },
            null,
            false,
            false
          )
          .then(resp => {
            if (resp.token) {
              this.showValidationModal = false;
              CustomHeadersService.setCustomHeaders({
                Authorization: resp.token
              });

              const validated = {
                personId: resp.personId,
                validated: resp.validated
              };
              const res = this.reservationService.updateLocalGuest(
                this.selectedGuest.guestId,
                validated
              );

              this.reservationService.setValidatedInfo(validated);
              this.$setCurrentReservation(res);
              this.$setIsQualifiedGuest(true);
              this.$setAuthenticatedPersonGuestId(this.selectedGuest.guestId);

              if (resp.personId) {
                this.$setCurrentPersonId(resp.personId);
              }

              this.$redirectGuestView(
                this.$route.params.reservationId,
                this.selectedGuest.guestId
              );
            }
          })
          .catch(error => {
            this.loading = false;
            if (error.status === 401) {
              FlashMessageService.error(this.$t("NOVO_FLUXO.INCORRECT_PIN"));
            } else {
              FlashMessageService.error(this.$t("NOVO_FLUXO.UNKNOW_ERROR_PIN"));
            }
          });
      }
    },
    cardClick: function(reservationId, guestId) {
      this.selectedGuest = {
        reservationId: reservationId,
        guestId: guestId
      };

      if (
        this.mediaSupported &&
        this.enableRecon &&
        !this.reconOpen &&
        !this.showBrowserModalRecomendation
      ) {
        this.reconOpen = true;
        return;
      }

      this.reconFail();
    },
    getReservation: async function(reservationId, hash) {
      const $context = this;
      try {
        const resp = await this.reservationService.getById({
          reservationId,
          hash
        });
        delete resp.links;
        $context.reservationService.setLocalReservation(resp);
        $context.$setCurrentReservation(resp);
      } catch (error) {
        FlashMessageService.warning(
          $context.$t("WELCOME.RESERVATION_NOT_FOUND_MESSAGE")
        );
        $context.$redirectSearch();
      }
    },
    reconSuccess(result) {
      if (result && result.personList) {
        this.personId = "";

        if (
          !this.personId &&
          result.personList &&
          result.personList.length > 0
        ) {
          this.personId = result.personList[0].id;
        }

        this.$setCurrentPersonId(this.personId);
        this.$setCurrentPhoto(result.image);

        this.$redirectGuestView(
          this.selectedGuest.reservationId,
          this.selectedGuest.guestId
        );
      }
    },
    reconFail(result) {
      if (result && result.image) {
        this.$setCurrentPhoto(result.image);
      } else {
        this.$setCurrentPhoto("");
      }

      this.reconOpen = false;

      if (this.selectedGuest.reservationId && this.selectedGuest.guestId) {
        this.$redirectGuestView(
          this.selectedGuest.reservationId,
          this.selectedGuest.guestId
        );
      }
    },
    getFullName: function(guest) {
      return `${guest.name} ${guest.lastName}`;
    },
    getPhotoUrl: function(guest) {
      if (this.isQualifiedGuest) {
        return (
          guest.photoUrl ||
          require("../../../../assets/images/generic-user.jpg")
        );
      } else {
        return require("../../../../assets/images/generic-user.jpg");
      }
    },
    redirectUser: async function(reservation, guest) {
      if (this.$customization && this.$customization.enableRedirect) {
        const strategy = this.$customization.redirectTo || 0;
        await this.strategyManager.setStrategy(strategy);
        await this.strategyManager.redirect(reservation, guest);
      } else {
        this.$redirectResume(guest.fnrhId);
      }
    }
  }
};
